import { Offcanvas } from 'bootstrap';

const mainNavEl = document.querySelector('.js-main-nav-layer');
if (mainNavEl) {
  // eslint-disable-next-line no-new
  const navLayer = new Offcanvas(mainNavEl);
  const toggleCheck = document.querySelector('.js-main-nav-toggle-check');

  if (toggleCheck) {
    toggleCheck.addEventListener('change', (ev) => {
      const { checked } = ev.target;
      if (checked) {
        navLayer.show();
      } else {
        navLayer.hide();
      }
    });

    mainNavEl.addEventListener('hide.bs.offcanvas', () => {
      toggleCheck.checked = false;
    });
  }
}
